module.exports = __webpack_public_path__ + "static/img/wechat.0fde5e16.png";